import { RiskMetric, TaskTypeEnum } from '@api';

export const STYLE_METRIC_NAME = 'Style';

// Task types whose catalog has a "Style" risk metric
export const STYLE_TASK_TYPES: TaskTypeEnum[] = [
  TaskTypeEnum.singleTurnChat,
  TaskTypeEnum.textGeneration,
  TaskTypeEnum.conversationalAgent,
  TaskTypeEnum.voiceAgent,
];

export const STYLE_MIN_LEVELS = 3;
export const STYLE_MAX_LEVELS = 10;

export const hasStyleMetric = (selectedRiskMetrics: Pick<RiskMetric, 'name'>[]) =>
  selectedRiskMetrics.some(metric => metric.name === STYLE_METRIC_NAME);

// scale 2 is pass/fail, 3-10 is that many evenly spaced levels; backend default is 2
export const getStyleScaleLabel = (scale = 2) => (scale === 2 ? 'Pass / fail' : `${scale} levels`);
